

import types from "../actions/actionTypes";
import initialState from "./initialState";


export default function sitesReducer(state = initialState.sitesList, action) {

     const merge = (current, updates) => {       
        let result = current.map(site => {
            const updateOrNothing = updates.find(pi => pi.id === site.id);
            if (updateOrNothing !== undefined) {
                return updateOrNothing;
            }
            return site;
         });   
        const existingIds = result.map(site => site.id);
        const newSites = updates.filter(site => !existingIds.includes(site.id));
        return [...result, ...newSites];   
    }

      const deleteSite = (current, id) => {
        return current.filter(site => site.id !== id);
    } 

    switch (action.type) {
        case types.LOAD_SITES_SUCCESS:
            return action.sitesList;
        case types.LOAD_SITES_UPDATE_SUCCESS:
            return merge(state, action.sitesList);
         case types.DELETED_SITE:    
            return deleteSite(state, action.id);
        case types.DELETED_SITE_INCOMING:
            return deleteSite(state, action.payload); 
        default:
            return state;
    }
}

